import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { Button } from "@chakra-ui/react";
import { SearchFilter, SearchFilterType, TaskStatusType } from "gql/graphql";
import { getTaskStatusDescription } from "modules/utils/Functions";

interface IProps {
  statusType: TaskStatusType;
  icon: React.ReactElement;
  isDisabled?: boolean;
  newSearchFilters: SearchFilter[];
  setNewSearchFilters: React.Dispatch<React.SetStateAction<SearchFilter[]>>;
}

const FiltersDrawerTaskStatusToggleButton = ({
  statusType,
  icon,
  isDisabled = false,
  newSearchFilters,
  setNewSearchFilters,
}: IProps) => {
  const title = getTaskStatusDescription(statusType);
  const searchFilterType = SearchFilterType.TaskStatusTypeList;

  const isToggled = newSearchFilters.some(
    (filter) =>
      filter.type === searchFilterType &&
      filter.stringListValue?.includes(statusType),
  );

  const onClick = useCallback(() => {
    setNewSearchFilters((prev) => {
      const _filter = prev.find((filter) => filter.type === searchFilterType);
      const _prevTaskStatusTypes = (_filter?.stringListValue ??
        []) as TaskStatusType[];

      let nextValues: TaskStatusType[] = [];
      if (isToggled) {
        nextValues = _prevTaskStatusTypes.filter((type) => type !== statusType);
      } else {
        nextValues = _prevTaskStatusTypes.includes(statusType)
          ? _prevTaskStatusTypes
          : [..._prevTaskStatusTypes, statusType];
      }

      const newFilters = [...prev].filter(
        (filter) => filter.type !== searchFilterType,
      );

      if (nextValues.length > 0) {
        newFilters.push({
          type: searchFilterType,
          stringListValue: nextValues,
        });
      }
      return newFilters;
    });
  }, [isToggled, searchFilterType, setNewSearchFilters, statusType]);

  return (
    <Button
      aria-label="unread"
      size="sm"
      variant="outline"
      rounded="full"
      leftIcon={icon}
      backgroundColor={isToggled ? colors.blueLight : "transparent"}
      iconSpacing={1}
      px={2}
      fontSize={14}
      fontWeight={500}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      {title}
    </Button>
  );
};

export default memo(FiltersDrawerTaskStatusToggleButton);
